import script from "./LichessPlayView.vue?vue&type=script&setup=true&lang=js"
export * from "./LichessPlayView.vue?vue&type=script&setup=true&lang=js"

import "./LichessPlayView.vue?vue&type=style&index=0&id=4d7fb144&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7fb144"]])

export default __exports__